export const formatMessageTime = (dateString) => {
  if (!dateString) return '';
  let timeStr = new Date(dateString).toLocaleTimeString([], {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
  return timeStr.replace(/(am|pm)/i, (match) => match.toUpperCase());
};


export const smartTime = (dateString) => {
  if (!dateString) return '';

  const msgDate = new Date(dateString);
  const now = new Date();

  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  const msgDay = new Date(msgDate.getFullYear(), msgDate.getMonth(), msgDate.getDate());

  if (msgDay.getTime() === today.getTime()) {
    return msgDate.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  } else if (msgDay.getTime() === yesterday.getTime()) {
    return 'Yesterday';
  } else {
    const day = String(msgDate.getDate()).padStart(2, '0');
    const month = String(msgDate.getMonth() + 1).padStart(2, '0'); 
    const year = msgDate.getFullYear();
    return `${day}/${month}/${year}`;
  }
};



export const groupMessagesByDay = (messages) => {
  if (!messages || messages.length === 0) return [];

  const groups = [];
  let currentDay = null;
  let currentGroup = [];

  messages.forEach((msg) => {
    const msgDate = new Date(msg.created_at);
    const dayKey = msgDate.toISOString().split('T')[0]; 

    if (dayKey !== currentDay) {
      if (currentGroup.length > 0) {
        groups.push({ day: currentDay, messages: currentGroup });
      }
      currentDay = dayKey;
      currentGroup = [msg];
    } else {
      currentGroup.push(msg);
    }
  });

  if (currentGroup.length > 0) {
    groups.push({ day: currentDay, messages: currentGroup });
  }

  return groups;
};



export const formatDayLabel = (dateString) => {
  if (!dateString) return '';

  const msgDate = new Date(dateString);
  const now = new Date();

  // Normalize to compare dates (ignore time)
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  const msgDay = new Date(msgDate.getFullYear(), msgDate.getMonth(), msgDate.getDate());

  if (msgDay.getTime() === today.getTime()) {
    return 'Today';
  } else if (msgDay.getTime() === yesterday.getTime()) {
    return 'Yesterday';
  } else {
    const day = String(msgDate.getDate()).padStart(2, '0');
    const month = String(msgDate.getMonth() + 1).padStart(2, '0');
    const year = msgDate.getFullYear();
    return `${day}/${month}/${year}`;
  }
};